module.exports = __webpack_public_path__ + "img/ide-statistics.b27fb9c2.svg";